export type GroupByType = 'customer' | 'product' | 'date' | undefined
export type SortByType = string | null | undefined

export function getApiSorting(
  groupBy: GroupByType,
  sortBy: SortByType
): string | null | undefined {
  if (!groupBy) {
    return sortBy
  }

  // If groupBy matches sortBy field, send sortBy to API
  if (sortBy?.includes(groupBy)) {
    return sortBy
  }

  // Otherwise, always send groupBy_asc to API for proper grouping
  return `${groupBy}_asc`
}

export function needsClientSideSort(
  groupBy: GroupByType,
  sortBy: SortByType
): boolean {
  // Client-side sorting is needed when we have a groupBy AND a sortBy that's different from groupBy
  return !!(groupBy && sortBy && !sortBy.includes(groupBy))
}
